import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-campaigns-list',
  templateUrl: './campaigns-list.component.html',
  styleUrls: ['./campaigns-list.component.scss']
})
export class CampaignsListComponent implements OnInit {

  loading = false;
  campaigns: any[] = [];
  count = 0;
  page = 1;
  pageSize = 10;

  constructor(private http: HttpClient, private toastr: ToastrService, private router: Router) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    const skip = (this.page - 1) * this.pageSize;
    this.http.get<any>(`${environment.serverUrl}/marketing/campaigns?skip=${skip}&take=${this.pageSize}`).subscribe({
      next: (res) => {
        this.campaigns = res?.data || [];
        this.count = res?.count || 0;
        this.loading = false;
      },
      error: (e) => {
        this.loading = false;
        console.error('Load campaigns failed', e);
        this.toastr.error(e?.error?.error || e?.message || 'Failed to load campaigns', 'Error');
      }
    });
  }

  onPageChange(page: number): void {
    this.page = page;
    this.load();
  }

  statusClass(status: string): string {
    switch ((status || '')) {
      case 'Completed': return 'badge bg-success';
      case 'Sending': return 'badge bg-primary';
      case 'Queued': return 'badge bg-warning';
      case 'Failed': return 'badge bg-danger';
      default: return 'badge bg-secondary';
    }
  }

  open(campaign: any): void {
    this.router.navigate(['/whatsapp-bulk/campaigns', campaign.id]);
  }

  newCampaign(): void {
    this.router.navigate(['/whatsapp-bulk/campaign-setup']);
  }
}
